export default __webpack_public_path__ + "static/media/sliders-v.3c411beb.svg";